import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import RouteSEO from "../components/seo/RouteSEO";

import HomePage from "../pages/Home";
import ProfilePage from "../pages/Profile";
import OnboardingPage from "../pages/Onboarding";
import MyRoadmapPage from "../pages/MyRoadmap";
import HowItWorksPage from "../pages/HowItWorksPage";
import RoadmapsPage from "../pages/RoadmapsPage";
import CommunityPage from "../pages/CommunityPage";
import JobPrepPage from "../pages/JobPrepPage";
import EditorPage from "../pages/EditorPage";
import DashboardPage from "../pages/DashboardPage";
import GoogleCalendarCallback from "../pages/GoogleCalendarCallback";
import TechnologyScopePage from "../pages/TechnologyScopePage";
import ChoosePathPage from "../pages/ChoosePathPage";
import MAANGPrepIntroPage from "../pages/MAANGPrepIntoPage";
import RoadmapDayDetail from "../pages/RoadmapDayDetailPage";
import ResetSuccess from "../pages/ResetSuccess";
import ResetPassword from "../pages/ResetPassword";
import CalendarContainer from "../pages/CalendarContainer";
import DevUtilsPage from "../pages/DevUtilsPage";
import ProductDevelopmentPhasesPage from "../components/home/ProductDevelopmentPhasesPage";
import TechnologyLandscapePage from "../components/home/TechnologyLandscapePage";
import ATSResumeGuidePage from "../pages/ATSResumeGuidePage";
import CareerClarityTestPage from "../pages/career-clarity-test/CareerClarityTestPage";
import CareerClarityTest from "../pages/career-clarity-test/CareerClarityTest";
import CareerClarityResult from "../pages/career-clarity-test/CareerClarityResult";
import PricingPage from "../pages/PricingPage";
import GoogleCalendarSuccess from "../pages/GoogleCalendarSuccess";
import MockInterview from "../pages/MockInterview";
import TasksBoard from "../pages/TasksBoard";
import SprintBoard from "../pages/SpringBoard";
import ProductGeneratorPage from "../pages/ProductGeneratorPage";
import ProductRoadmapBuilderPage from "../pages/ProductRoadmapBuilderPage";
import MyProductRoadmapPage from "../pages/MyProductRoadmapPage";
import ProductCalendarViewPage from "../pages/ProductCalendarViewPage";
import ProductTasksBoardPage from "../pages/ProductTasksBoardPage";
import ProductDashboardPage from "../pages/ProductDashboardPage";
import AIRoadmapAssistantPage from "../pages/AiMentorChatPage";
import AIMentorChatPage from "../pages/AiChatMentorGeneral";
import AiMentorsPage from "../pages/AiMentorsPage";
import FocusWithoutPhonePage from "../pages/FocusWithoutPhonePage";
import CommunityFeed from "../pages/CommunityFeed";
import CreatePost from "../pages/CreatePost";
import PrivacyPolicyPage from "../pages/PrivacyPolicyPage";
import CookiesPolicyPage from "../pages/CookiesPolicyPage";
import TermsOfServicePage from "../pages/TermsOfServicePage";
import CodePracticePage from "../pages/CodePracticePage";
import CodePracticeWorkspacePage from "../pages/CodePracticeWorkspacePage";
import JsonFormatterPage from "../pages/JsonFormatterPage";
import SqlPracticePage from "../pages/SqlPracticePage";
import SupportCenterPage from "../pages/SupportCenterPage";
import FeaturesPage from "../pages/FeaturesPage";
import LearnersPage from "../pages/LearnersPage";
import FeedbackPage from "../pages/FeedbackPage";
import MySubscriptionsPage from "../pages/MySubscriptionsPage";

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return null;
  return user ? children : <Navigate to="/" replace />;
}

export default function AppRouter() {
  return (
    <>
      <RouteSEO />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/features" element={<FeaturesPage />} />
        <Route path="/roadmaps" element={<RoadmapsPage />} />
        <Route path="/community" element={<CommunityPage />} />
        <Route path="/job-prep" element={<JobPrepPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route
          path="/development-helper-functions"
          element={<DevUtilsPage />}
        />
        <Route
          path="/product-development-phases"
          element={<ProductDevelopmentPhasesPage />}
        />
        <Route path="/mock-interview" element={<MockInterview />} />
        <Route
          path="/career-clarity-home"
          element={<CareerClarityTestPage />}
        />
        <Route
          path="/career-clarity/result"
          element={<CareerClarityResult />}
        />
        <Route path="/career-clarity" element={<CareerClarityTest />} />
        <Route
          path="/ats-resume-guilde-page"
          element={<ATSResumeGuidePage />}
        />
        <Route
          path="/technologies-need-to-build-products"
          element={<TechnologyLandscapePage />}
        />
        <Route path="/reset-success" element={<ResetSuccess />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/choose-career-page" element={<ChoosePathPage />} />
        <Route path="/maang-prep-intro-page" element={<MAANGPrepIntroPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/cookies-policy" element={<CookiesPolicyPage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route path="/technology-scope" element={<TechnologyScopePage />} />
        <Route path="/code-practice" element={<CodePracticePage />} />
        <Route
          path="/code-practice/:language"
          element={<CodePracticeWorkspacePage />}
        />
        <Route path="/json-formatter" element={<JsonFormatterPage />} />
        <Route path="/sql-practice" element={<SqlPracticePage />} />
        <Route path="/support" element={<SupportCenterPage />} />
        <Route path="/feedback" element={<FeedbackPage />} />
        <Route
          path="/learners"
          element={
            <PrivateRoute>
              <LearnersPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <ProfilePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/my-subscriptions"
          element={
            <PrivateRoute>
              <MySubscriptionsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile/:uid"
          element={
            <PrivateRoute>
              <ProfilePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/my-roadmap"
          element={
            <PrivateRoute>
              <MyRoadmapPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <DashboardPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/api/google/callback"
          element={
            <PrivateRoute>
              <GoogleCalendarCallback />
            </PrivateRoute>
          }
        />
        <Route
          path="/community/feeds"
          element={
            <PrivateRoute>
              <CommunityFeed />
            </PrivateRoute>
          }
        />
        <Route
          path="/community/feeds/create"
          element={
            <PrivateRoute>
              <CreatePost />
            </PrivateRoute>
          }
        />
        <Route
          path="/edit-post/:postId"
          element={
            <PrivateRoute>
              <CreatePost />
            </PrivateRoute>
          }
        />
        <Route
          path="/google-calendar/success"
          element={
            <PrivateRoute>
              <GoogleCalendarSuccess />
            </PrivateRoute>
          }
        />
        <Route
          path="/roadmap/calendar"
          element={
            <PrivateRoute>
              <CalendarContainer />
            </PrivateRoute>
          }
        />
        <Route
          path="/editor"
          element={
            <PrivateRoute>
              <EditorPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/create-roadmap"
          element={
            <PrivateRoute>
              <OnboardingPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/tasks-board/day"
          element={
            <PrivateRoute>
              <TasksBoard />
            </PrivateRoute>
          }
        />
        <Route
          path="/spring-board"
          element={
            <PrivateRoute>
              <SprintBoard />
            </PrivateRoute>
          }
        />
        <Route
          path="/product-generator"
          element={
            <PrivateRoute>
              <ProductGeneratorPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/create-product-roadmap"
          element={
            <PrivateRoute>
              <ProductRoadmapBuilderPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/my-product-roadmap"
          element={
            <PrivateRoute>
              <MyProductRoadmapPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/product-roadmap/calendar"
          element={
            <PrivateRoute>
              <ProductCalendarViewPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/product-tasks-board/day"
          element={
            <PrivateRoute>
              <ProductTasksBoardPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/product-dashboard"
          element={
            <PrivateRoute>
              <ProductDashboardPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/ai-mentors"
          element={
            <PrivateRoute>
              <AiMentorsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/focus-without-phone"
          element={
            <PrivateRoute>
              <FocusWithoutPhonePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/ai-mentor-chat"
          element={
            <PrivateRoute>
              <AIRoadmapAssistantPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/ai-mentor-chat/:mentorId"
          element={
            <PrivateRoute>
              <AIMentorChatPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/roadmap/day"
          element={
            <PrivateRoute>
              <RoadmapDayDetail />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
